import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import Sketch from "src/components/common/sketch";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 
    MyDate, 
    Select, 

    defaultEmptyDateTime, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function WorkLogForm({
    formRequired,
    form, /* for optional forms */
    formName, /* for required forms */
    title, closeIt, items, 
    setWorkLogs, 
    /*optional params below*/
    picsLimit,
    noPDF,
    sendEmail,
    prefix,
    suffix, 
    correctiveActionNeed,

    // workLog
    requiredForms, 
    workLogHashKey, 
    userName
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const curForm = formRequired?
    (JSON.parse(requiredForms)[formName] ?? {}):
    form;
    //--------------------------------------------------------------------------------------------
    const formContent = (Object.fromEntries(
        curForm.content !== undefined?
        [
            ...items.map(f => [f.title, JSON.parse(curForm.content)[f.title]]),
            ...(items.some(i => i.type === "latlng")?
            [["latitude", JSON.parse(curForm.content).latitude ?? ""]]:[]),
            ...(items.some(i => i.type === "latlng")?
            [["longitude", JSON.parse(curForm.content).longitude ?? ""]]:[]),
            ...(correctiveActionNeed?[
                ["Corrective Action", JSON.parse(curForm.content)["Approval Notes"] ?? JSON.parse(curForm.content)["Corrective Action"]],
                ["Action Status", JSON.parse(curForm.content)["Approval Notes"]?"Completed":JSON.parse(curForm.content)["Action Status"]]
            
            ]:[])
        ]
        :
        items.map(f => [f.title, f.default ?? ""])
    ));
    //-----------------------------------------
    const [itemChecked, setItemChecked] = useState(formContent);
    //-----------------------------------------
    const [picData, setPicData] = useState([]);
    const [defualtPicData, setDefaultPicData] = useState([]);
    //-----------------------------------------
    const [showSketch, setShowSketch] = useState(false);
    const [sketches, setSketches] = useState([]);
    const [defaultSketches, setDefaultSketches] = useState([]);
    //-----------------------------------------
    const [showSketch2, setShowSketch2] = useState(false);
    const [sketches2, setSketches2] = useState([]);
    const [defaultSketches2, setDefaultSketches2] = useState([]);
    //--------------------------------------------------------------------------------------------
    const handleForm = async key => {
        if(!picData.length && !noPDF && key === "Submit"){
            window.alert("Please sign!");
            return; 
        }
        const curFormContent = JSON.parse(
            JSON.stringify(Object.fromEntries([
            ...items.map(f => [f.title, f.value || itemChecked[f.title]]),
                (items.some(i => i.type === "latlng")?
                ["latitude", itemChecked.latitude || ""]:[]),
                (items.some(i => i.type === "latlng")?
                ["longitude", itemChecked.longitude || ""]:[]),
                ...(correctiveActionNeed?[
                    ["Corrective Action", itemChecked["Corrective Action"]],
                    ["Action Status", itemChecked["Action Status"]]

                ]:[])
            ]))
        );
        if(itemChecked["Action Status"] === "Completed" && !sketches2.length){
            window.alert("The photos are requred for the ensuring completion.");
            return;
        }
        let isContentChanged = false;
        for(let key in itemChecked){
            if((itemChecked[key] ?? "") !== (formContent[key] ?? "")) isContentChanged = true;
        }
        let isSketchesChanged = JSON.stringify(defaultSketches) !== JSON.stringify(sketches);
        for(let sketch of sketches){
            if(defaultSketches.map(defaultSketch => defaultSketch.data).includes(sketch.data)){
                sketch.exist = "yes";
            }
        }
        let isSketchesChanged2 = JSON.stringify(defaultSketches2) !== JSON.stringify(sketches2);
        for(let sketch2 of sketches2){
            if(defaultSketches2.map(defaultSketch2 => defaultSketch2.data).includes(sketch2.data)){
                sketch2.exist = "yes";
            }
        }
        let isSignChanged = JSON.stringify(defualtPicData) !== JSON.stringify(picData);
        if(!isContentChanged && !isSketchesChanged && !isSketchesChanged2 && !isSignChanged && !window.confirm("Are you sure to submit without any changes?")){
            closeIt();
            return;
        }
        const formData = new MyFormData();
        formData.append("isSignChanged", isSignChanged?"Yes":"No");//php & g
        formData.append("isSketchesChanged", isSketchesChanged?"Yes":"No");//php & g
        formData.append("isSketchesChanged2", isSketchesChanged2?"Yes":"No");//php & g
        formData.append("data", JSON.stringify(curFormContent));//php & g
        formData.append("title", title);//php & g
        formData.append("workLogHashKey", workLogHashKey);//php
        formData.append("cancel", itemChecked.Cancel);//php
        if(key === "Submit" && noPDF !== true){
            formData.append("sendEmail", sendEmail === true?"yes":"no");//php
            formData.append("submitTime", (new MyDate()).ss());//g
            formData.append("submitDate", (new MyDate()).s());//g
            formData.append("memberName", userName ?? user.userName);//g
            formData.append("form", "form");//g
            formData.append("sign", document.getElementById("esign")?.toDataURL());//g
        }else{
            if(noPDF) formData.append("noPDF", "yes");//php
            formData.append("action", "Save");//php
        }
        if(formRequired){
            formData.append("formRequired", "yes"); //php
            formData.append("formName", formName);//php
        }else{
            formData.append("formRequired", "no"); //php
            formData.append("formHashKey", curForm.hashKey);//php
        }
        formData.append("sketches", JSON.stringify(sketches.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?/**/[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:[]
        }))));//php & g
        formData.append("sketches2", JSON.stringify(sketches2.map(e => ({
            ...e, sketchBgImg: e.sketchBgImg?/**/[
                e.sketchBgImg[0].src, 
                e.sketchBgImg[1],
                e.sketchBgImg[2],
                e.sketchBgImg[3],
                e.sketchBgImg[4]
            ]:[]
        }))));//php & g
        formData.append("signData", JSON.stringify(picData));//php & g
        const potentialitem = items.find(item => item.docNum);
        formData.append("docNum", potentialitem?itemChecked[potentialitem.title]:"");//php
        //------------------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("workLogs/forms.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //------------------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, workLogFiles:(
                w.workLogHashKey === workLogHashKey && noPDF !== true && key === "Submit"?
                vehicleFormRes.data[0]:
                w.workLogFiles
            ), forms:(
                w.workLogHashKey === workLogHashKey && formRequired !== true?
                (noPDF === true || key === "Save"?JSON.stringify(vehicleFormRes.data):vehicleFormRes.data[1]):
                w.forms
            ), requiredForms:(
                w.workLogHashKey === workLogHashKey && formRequired === true?
                (noPDF === true || key === "Save"?JSON.stringify(vehicleFormRes.data):vehicleFormRes.data[1]):
                w.requiredForms
            )
        })));
        if(sendEmail && key === "Submit"){
            window.alert("We have sent an email to the management of the form you submitted. Please call if urgent.");
        }
        closeIt();
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("workLogHashKey", workLogHashKey);
            if(formRequired){
                formData.append("formRequired", "yes");
                formData.append("formName", formName);
            }else{
                formData.append("formRequired", "no");
                formData.append("formHashKey", curForm.hashKey);
            }
            formData.append("action", "Read");
            //---------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("workLogs/forms.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------
            const curPicData = JSON.parse(
                (res.data.sign?.indexOf("error") === -1)?
                res.data.sign:"[]"
            );
            setPicData(curPicData);
            setDefaultPicData(curPicData);
            const curSketches = JSON.parse(res.data.sketches && (res.data.sketches.indexOf("error") === -1)?res.data.sketches:"[]") ?? [];
            curSketches.forEach(e => {
                if(e.sketchBgImg){
                    const img = new Image();
                    img.src = e.sketchBgImg[0];
                    e.sketchBgImg[0] = img; 
                }
            })
            setSketches(curSketches);
            setDefaultSketches(curSketches);
            const curSketches2 = JSON.parse(res.data.sketches2 && (res.data.sketches2.indexOf("error") === -1)?res.data.sketches2:"[]") ?? [];
            curSketches2.forEach(e => {
                if(e.sketchBgImg){
                    const img = new Image();
                    img.src = e.sketchBgImg[0];
                    e.sketchBgImg[0] = img; 
                }
            });
            setSketches2(curSketches2);
            setDefaultSketches2(curSketches2);
        }
        getData();
        return () => {isMounted = false;}
    },[workLogHashKey, curForm.hashKey, formName, formRequired, setShowLoader]);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {title}
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {() => handleForm("Submit")}
            actionKey = {"Submit"}
            onSave = {() => handleForm("Save")}
        >
            <div className = "my-3"/>
            {prefix}
            <div>
                {items.map((item, itemNumber) => 
                (!item.parentNo || (itemChecked[item.parentNo] !== "Yes" && itemChecked[item.parentNo2] !== "Yes")) &&
                (!item.parentYes || itemChecked[item.parentYes] !== "Yes") 
                ?
                <div key = {itemNumber} className = "blk5 mb-2 d-flex align-items-center">
                    <label htmlFor = {item.title} className = {`font-weight-bold mr-3` + (item.nowrap?" text-nowrap":"")}>{item.showTitle ?? item.title}</label>
                    {item.type === "latlng"?<>
                    <label htmlFor = "lat" className = "font-weight-bold mr-3">Latitude:</label>
                    <input
                        id = "lat"
                        type = "number"
                        step = "any"
                        className = "form-control text-center flex-grow-1 mr-3"
                        required = {itemChecked.longitude}
                        name = "latitude"
                        value = {itemChecked.latitude ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                latitude: e.currentTarget.value, 
                                [item.title]: 
                                e.currentTarget.value !== "" && 
                                itemChecked.longitude !== ""?
                                `${e.currentTarget.value}, ${itemChecked.longitude}`:""
                            });
                        }} 
                    />
                    <label htmlFor = "lng" className = "font-weight-bold mr-3">Longitude:</label>
                    <input
                        id = "lng"
                        type = "number"
                        step = "any"
                        className = "form-control text-center flex-grow-1 mr-3"
                        required = {itemChecked.latitude}
                        name = "longitude"
                        value = {itemChecked.longitude ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                longitude: e.currentTarget.value, 
                                [item.title]: 
                                e.currentTarget.value !== "" && 
                                itemChecked.latitude !== ""?
                                `${itemChecked.latitude}, ${e.currentTarget.value}`:""
                            });
                        }}
                    />
                    <label>
                        <span className = "btn btn-primary mr-3" onClick = {() => {
                            if(navigator.geolocation){
                                navigator.geolocation.getCurrentPosition(pos => {
                                    setItemChecked({
                                        ...itemChecked, 
                                        latitude: pos.coords.latitude,
                                        longitude:pos.coords.longitude, 
                                        [item.title]:`${pos.coords.latitude}, ${pos.coords.longitude}`
                                    });
                                }, error => alert(error.message), {enableHighAccuracy: true, timeout: 15000});
                            }else{
                                setItemChecked({
                                    ...itemChecked, 
                                    latitude: "", 
                                    longitude: "", 
                                    [item.title]: ""
                                });
                            }
                        }}>
                            Get Location
                        </span>
                        <span>(GIS Grade)</span>
                    </label>
                    </>:<></>}
                    {item.type === "select"?
                    <select
                        id = {item.title}
                        className = "form-control w-100 text-center"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                    >
                        <option value = {""}>Select</option>
                        {item.options.map((v, i) => <option key = {i}>{v}</option>)}
                    </select>
                    :<></>}
                    {item.type === "textarea"?
                    <textarea
                        id = {item.title}
                        rows = {6}
                        className = "form-control text-center flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "text"?
                    <input
                        id = {item.title}
                        type = "text"
                        placeholder = {item.example}
                        className = "form-control text-center w-100"
                        required = {item.required}
                        disabled = {item.disabled}
                        readOnly = {item.readOnly}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "date"?
                    <input
                        id = {item.title}
                        type = "date"
                        min = {item.min ?? "1900-01-01"}
                        max = {item.max ?? "2999-12-31"}
                        className = "text-center form-control flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked({
                                ...itemChecked, 
                                [target.name]: target.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "time"?
                    <input
                        id = {item.title}
                        type = "time"
                        min = {item.min}
                        max = {item.max}
                        className = "text-center form-control flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            const target = e.currentTarget;
                            setItemChecked({
                                ...itemChecked, 
                                [target.name]: target.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "number"?
                    <input
                        id = {item.title}
                        type = "number"
                        min = {item.min}
                        max = {item.max}
                        step = {item.step ?? "any"}
                        className = "form-control w-100 text-center"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title] ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                    />
                    :<></>}
                    {item.type === "radio"?
                    <div className = "d-flex">
                    <input
                        type = "radio"
                        required = {item.required}
                        id = {item.title + " Yes"}
                        name = {item.title}
                        checked = {(
                            itemChecked[item.title] !== undefined && 
                            itemChecked[item.title].substring(0, 3) === "Yes"
                        ) || false}
                        value = {`Yes`}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                        className = "mr-2 cssCheckBox"
                    />
                    <label htmlFor = {item.title + " Yes"} className = "mr-3 mb-0">Yes</label>
                    <input
                        type = "radio"
                        required = {item.required}
                        id = {item.title + " No"}
                        name = {item.title}
                        checked = {(
                            itemChecked[item.title] !== undefined && 
                            itemChecked[item.title].substring(0, 2) === "No"
                        ) || false}
                        value = {`No`}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: e.currentTarget.value
                            });
                        }}
                        className = "mr-2 cssCheckBox"
                    />
                    <label htmlFor = {item.title + " No"} className = "mr-3 mb-0">No</label>
                    </div>:<></>}
                    {itemChecked[item.title] === "No" && item.onNoText !== undefined?<>
                    <label>{item.onNoText}</label>
                    </>:<></>}
                    {itemChecked[item.title] === "Yes" && item.onYesText !== undefined?<>
                    <label>{item.onYesText}</label>
                    </>:<></>}
                    {itemChecked[item.title] && itemChecked[item.title].substring(0, 2) === "No" && item.onNo !== undefined?<>
                    {item.onNo === "textarea"?
                        <textarea
                            rows = {6}
                            className = "form-control text-center flex-grow-1"
                            required = {item.required}
                            name = {item.title}
                            value = {itemChecked[item.title].substring(4) ?? ""}
                            onChange = {e => {
                                setItemChecked({
                                    ...itemChecked, 
                                    [e.currentTarget.name]: `No, ${e.currentTarget.value}`
                                });
                            }}
                    />:<></>}
                    {item.onNo === "text"?
                    <input
                        type = {item.onNo}
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title].substring(4) ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: `No, ${e.currentTarget.value}`
                            });
                        }}
                    />:<></>}
                    </>:<></>}
                    {itemChecked[item.title] && itemChecked[item.title].substring(0, 3) === "Yes" && item.onYes!== undefined?<>
                    {item.onYes === "textarea"?
                    <textarea
                        rows = {6}
                        className = "form-control text-center flex-grow-1"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title].substring(5) ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: `Yes, ${e.currentTarget.value}`
                            });
                        }}
                    />:<></>}
                    {item.onYes === "text"?
                    <input
                        type = {item.onYes}
                        className = "form-control"
                        required = {item.required}
                        name = {item.title}
                        value = {itemChecked[item.title].substring(5) ?? ""}
                        onChange = {e => {
                            setItemChecked({
                                ...itemChecked, 
                                [e.currentTarget.name]: `Yes, ${e.currentTarget.value}`
                            });
                        }}
                    />:<></>}
                    </>:<></>}
                    {item.type === "object"?<div className = "flex-grow-1">
                        {JSON.parse(itemChecked[item.title]).map((x, xi) => <div key = {xi} className = "border rounded p-2 m-2">
                        {item.schema.map((property, propertyIndex) => <div key = {propertyIndex} className = "d-flex align-items-center my-2">
                            <label htmlFor = {property.title} className = "font-weight-bold mr-3">{property.title}</label>
                            {property.type === "radio"?<>
                            <input
                                type = "radio"
                                required = {property.required}
                                id = {item.title + " " + xi + " " + property.title + " Yes"}
                                name = {item.title + " " + xi + " " + property.title}
                                checked = {(
                                    JSON.parse(itemChecked[item.title])[xi][property.title] && 
                                    JSON.parse(itemChecked[item.title])[xi][property.title].substring(0, 3) === "Yes"
                                ) || false}
                                value = {`Yes`}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    if(target.checked){
                                        const arr = JSON.parse(itemChecked[item.title]);
                                        setItemChecked(itemChecked => ({
                                            ...itemChecked, 
                                            [item.title]: JSON.stringify([
                                                ...arr.slice(0, xi), 
                                                {...arr[xi], [property.title]: target.value},
                                                ...arr.slice(xi + 1)
                                            ])
                                        }));
                                    }
                                }}
                                className = "mr-2 cssCheckBox"
                            />
                            <label htmlFor = {x.title + " Yes"} className = "mr-3 mb-0">Yes</label>
                            <input
                                type = "radio"
                                required = {property.required}
                                id = {item.title + " " + xi + " " + property.title + " No"}
                                name = {item.title + " " + xi + " " + property.title}
                                checked = {(
                                    JSON.parse(itemChecked[item.title])[xi][property.title] && 
                                    JSON.parse(itemChecked[item.title])[xi][property.title].substring(0, 3) === "No"
                                ) || false}
                                value = {`No`}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    if(target.checked){
                                        const arr = JSON.parse(itemChecked[item.title]);
                                        setItemChecked(itemChecked => ({
                                            ...itemChecked, 
                                            [item.title]: JSON.stringify([
                                                ...arr.slice(0, xi), 
                                                {...arr[xi], [property.title]: target.value},
                                                ...arr.slice(xi + 1)
                                            ])
                                        }));
                                    }
                                }}
                                className = "mr-2 cssCheckBox"
                            />
                            <label htmlFor = {x.title + " No"} className = "mr-3 mb-0">No</label>
                            </>:<></>}
                            {property.type === "Select"?
                            <div className = "w-100">
                            <Select
                                inputId = {property.title}
                                value = {property.options
                                    .find(option => 
                                        option.value
                                        ===
                                        JSON.parse(itemChecked[item.title])[xi][property.title]
                                    )
                                }
                                options = {property.options}
                                onChange = {e => {
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: e?.value ?? ""},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            />
                            </div>:<></>}
                            {property.type === "text"?
                            <input
                                id = {property.title}
                                type = "text"
                                required = {property.required}
                                className = "form-control text-center flex-grow-1"
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            />:<></>}
                            {property.type === "textarea"?
                            <textarea
                                id = {property.title}
                                required = {property.required}
                                className = "form-control text-center flex-grow-1"
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            />:<></>}
                            {property.type === "select"?
                            <select
                                id = {property.title}
                                disabled = {property.disabled}
                                className = "form-control text-center flex-grow-1"
                                required = {property.required}
                                name = {property.title}
                                value = {JSON.parse(itemChecked[item.title])[xi][property.title] || ""}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    const arr = JSON.parse(itemChecked[item.title]);
                                    setItemChecked(itemChecked => ({
                                        ...itemChecked, 
                                        [item.title]: JSON.stringify([
                                            ...arr.slice(0, xi), 
                                            {...arr[xi], [property.title]: value},
                                            ...arr.slice(xi + 1)
                                        ])
                                    }));
                                }}
                            >
                                <option value = "">Select</option>
                                {property.options.map((option, optionIndex) => <option key = {optionIndex} value = {option.value}>{option.label}</option>)}
                            </select>:<></>}
                            {property.type === "date"?
                            <input
                                id = {property.title}
                                type = "date"
                                min = {property.min ?? "1900-01-01"}
                                max = {property.max ?? "2999-12-31"}
                                className = "text-center form-control flex-grow-1"
                                required = {property.required}
                                name = {property.title}
                                value = {itemChecked[property.title] ?? ""}
                                onChange = {e => {
                                    const target = e.currentTarget;
                                    setItemChecked({
                                        ...itemChecked, 
                                        [target.name]: target.value
                                    });
                                }}
                            />
                            :<></>}
                        </div>)}
                        <button
                            type = "button"
                            className = "btn btn-danger"
                            onClick = {() => {
                                const arr = JSON.parse(itemChecked[item.title]);
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [item.title]: JSON.stringify([
                                        ...arr.slice(0, xi), 
                                        ...arr.slice(xi + 1)
                                    ])
                                }));
                            }}
                        >
                            Delete
                        </button>
                        </div>)}
                        <button
                            type = "button"
                            className = "btn btn-success"
                            onClick = {() => {
                                setItemChecked(itemChecked => ({
                                    ...itemChecked, 
                                    [item.title]: JSON.stringify([...JSON.parse(itemChecked[item.title]), 
                                        Object.fromEntries(item.schema.map(f => [f.title, f.default || ""]))
                                    ])
                                }));
                            }}
                        >
                            Add
                        </button>
                    </div>:<></>}
                    {item.suffix}
                </div>:<></>)}
            </div>
            {suffix}
            {curForm.formSubmitTime !== defaultEmptyDateTime && user.project !== "no" && correctiveActionNeed?
            <div className="border rounded p-3" style = {{color: "darkred"}}>
            <div className = "mb-2 blk5 d-flex align-items-center">
                <label htmlFor = "correctiveAction" className = "font-weight-bold mr-3">Corrective Action</label>
                <textarea
                    id = "correctiveAction"
                    rows = {6}
                    className = "form-control text-center flex-grow-1"
                    style = {{color: "darkred"}}
                    name = {"Corrective Action"}
                    value = {itemChecked["Corrective Action"] ?? ""}
                    onChange = {e => {
                        setItemChecked({
                            ...itemChecked, 
                            "Corrective Action": e.currentTarget.value
                        });
                    }}
                />
            </div>
            <div className = "mb-2 blk5 d-flex align-items-center">
                <label htmlFor = "actionStatus" className = "font-weight-bold mr-3">Action Status</label>
                <select
                    id = "actionStatus"
                    className = "form-control flex-grow-1"
                    style = {{color: "darkred"}}
                    name = {"Action Status"}
                    value = {itemChecked["Action Status"] ?? ""}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        if(value === "Completed"){
                            setItemChecked({
                                ...itemChecked, 
                                "Action Status": value,
                                "Completed Time": new MyDate().s() + " " + new MyDate().ss()
                            });
                        }else{
                            setItemChecked({
                                ...itemChecked, 
                                "Action Status": value,
                                "Completed Time": undefined
                            });
                        }
                    }}
                >
                    <option value = "">Select</option>
                    <option>In Progress</option>
                    <option>Completed</option>
                </select>
            </div>
            <div className = "blk5 d-flex align-items-center">
                {picsLimit !== undefined?
                <Sketch
                    id = {"admin"}
                    mainClassName = "mb-2"
                    sketches = {sketches2} 
                    setSketches = {setSketches2}
                    limit = {picsLimit}
                    showSketch = {showSketch2}
                    setShowSketch = {setShowSketch2}
                />:<></>}
            </div>
            </div>:<></>}
            {picsLimit !== undefined?
            <Sketch
                mainClassName = "mb-2"
                sketches = {sketches} 
                setSketches = {setSketches}
                limit = {picsLimit}
                showSketch = {showSketch}
                setShowSketch = {setShowSketch}
            />:<></>}
            <div className = "blk5 mb-2 d-flex">
                <label className = "required-field mr-3">Member name:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "memberName"
                    defaultValue = {userName ?? user.userName}
                />
                <label className = "required-field mr-3">Date:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "submitDate"
                    value = {(new MyDate()).s()}
                />
            </div>
            {noPDF?<></>:
            <Esign
                buttonClassName = "my-2"
                picData = {picData}
                setPicData = {setPicData}
            />
            }
        </Modal>
    )    
}